import React from "react";
import bg from "assests/Project/background.jpg";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import Container from "Components/Container/Container";

const Hero = ({ onHandleSelectedCat, selectedCat, data }) => {
  return (
    <section
      style={{ backgroundImage: `url(${bg})` }}
      className="scroll-section-special background "
    >
      <Container className="pb-12">
        <div className="text-2xl text-[#808080] flex items-center gap-x-2 pt-32 lg:pt-60">
          <Link to="/" className="hover:underline">
            Home
          </Link>
          <span>|</span>
          <p>Projects</p>
        </div>
        <h2 className="text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl bebas uppercase mt-2 tracking-[8px] sm:tracking-[12px]">
          Our Projects
        </h2>
        <div className="flex items-center content-center overflow-scroll lg:overflow-hidden lg:flex-wrap gap-2 lg:gap-6 mt-6 ">
          {[...new Set(data.map(({ category }) => category))].map(
            (uniqueCategory, index) => (
              <button
                onClick={() => onHandleSelectedCat(uniqueCategory)}
                className={`min-w-[fit-content] border border-light px-8 py-2.5 ${
                  selectedCat === uniqueCategory
                    ? "bg-light text-black"
                    : "bg-[#000000a9] text-white "
                }`}
                key={index}
              >
                {uniqueCategory}
              </button>
            )
          )}
        </div>
        <span className="lg:hidden text-black rounded-md animate-pulse mt-2 text-lg flex items-end  justify-end bg-white w-max ml-auto py-1">
          <CaretRight />
        </span>
      </Container>
    </section>
  );
};

export default Hero;
